import { render, staticRenderFns } from "./LoadingResources.vue?vue&type=template&id=a7e83de4&lang=pug"
import script from "./LoadingResources.vue?vue&type=script&lang=js"
export * from "./LoadingResources.vue?vue&type=script&lang=js"
import style0 from "./LoadingResources.vue?vue&type=style&index=0&id=a7e83de4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports